import { refreshMunicipalPropertyManagement } from "@/domain/municipal-property/lib/refresh-municipal-property-management";
import { DeleteMunicipalPropertyMutation } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { QueryClient, useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { DELETE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT } from "./delete-municipal-property-mutation.gql";

export function useMoveMunicipalPropertyToTrash({
  workspaceId,
  propertyId,
}: {
  workspaceId: string;
  propertyId: string;
}): UseMutationResult<DeleteMunicipalPropertyMutation, Error, void> {
  const queryClient: QueryClient = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<DeleteMunicipalPropertyMutation> =>
      createOperationClient("DeleteMunicipalProperty").request(DELETE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT, {
        id: propertyId,
      }),
    onSuccess: (): Promise<void> =>
      refreshMunicipalPropertyManagement({ queryClient, scope: { workspaceId, propertyIdList: [propertyId] } }),
  });
}
